import {
  SET_CHAT_CONVERSATION,
  SET_CHAT_MESSAGES,
  UPSERT_CHAT_MESSAGE,
  SET_CHAT_PRESENCE,
  APPLY_CHAT_READ_RECEIPT,
  RESET_CHAT,
  SET_CHAT_INBOX,
  UPSERT_INBOX_ITEM,
  PREPEND_CHAT_MESSAGES,
  APPEND_CHAT_MESSAGES,
} from '../Types/types';

const initialState = {
  conversation: null,
  messages: [],
  inbox: [],
};

export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CHAT_CONVERSATION:
      return { ...state, conversation: action.payload };

    case SET_CHAT_MESSAGES:
      return { ...state, messages: action.payload };

    case PREPEND_CHAT_MESSAGES:
      return { ...state, messages: [...action.payload, ...state.messages] };

    case APPEND_CHAT_MESSAGES:
      return { ...state, messages: [...state.messages, ...action.payload] };

    case UPSERT_CHAT_MESSAGE: {
      const msg = action.payload;
      const idx = state.messages.findIndex((m) => m.id === msg.id);
      let updated;
      if (idx >= 0) {
        updated = state.messages.map((m, i) => (i === idx ? { ...m, ...msg } : m));
      } else {
        updated = [...state.messages, msg].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at),
        );
      }
      return { ...state, messages: updated };
    }

    case SET_CHAT_PRESENCE:
      if (!state.conversation) return state;
      return {
        ...state,
        conversation: {
          ...state.conversation,
          recruiter_online: action.payload.recruiter_online,
          candidate_online: action.payload.candidate_online,
        },
      };

    case APPLY_CHAT_READ_RECEIPT: {
      const { sender_type, last_read_message_id } = action.payload;
      const cutoffIdx = state.messages.findIndex((m) => m.id === last_read_message_id);
      if (cutoffIdx < 0) return state;
      const cutoffTime = new Date(state.messages[cutoffIdx].created_at);
      const updated = state.messages.map((m) => {
        if (m.sender_type !== sender_type) return m;
        return { ...m, is_read_by_other: new Date(m.created_at) <= cutoffTime };
      });
      return { ...state, messages: updated };
    }

    case SET_CHAT_INBOX:
      return { ...state, inbox: action.payload };

    case UPSERT_INBOX_ITEM: {
      const item = action.payload;
      if (!item?.job_candidate_id) return state;
      const key = String(item.job_candidate_id);
      const idx = state.inbox.findIndex((r) => String(r.job_candidate_id) === key);
      let updated;
      if (idx >= 0) {
        const definedFields = Object.fromEntries(
          Object.entries(item).filter(([, v]) => v !== undefined && v !== null),
        );
        updated = state.inbox.map((r, i) => (i === idx ? { ...r, ...definedFields } : r));
      } else {
        updated = [...state.inbox, { ...item, last_message_at: item.last_message_at || new Date().toISOString() }];
      }
      updated = [...updated].sort((a, b) => {
        const ta = a.last_message_at ? new Date(a.last_message_at).getTime() : 0;
        const tb = b.last_message_at ? new Date(b.last_message_at).getTime() : 0;
        return tb - ta;
      });
      return { ...state, inbox: updated };
    }

    case RESET_CHAT:
      return initialState;

    default:
      return state;
  }
}
